import React from 'react';

import { Card } from '../ui/card';
import SmartImage from './SmartImage';

/** Menu cards shared by the home page teaser and the full menu page. */
export const DonutGrid = ({ items, testIdPrefix = 'donut' }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
    {items.map((item) => (
      <Card
        key={item.id}
        className="group overflow-hidden border-0 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
        data-testid={`${testIdPrefix}-card-${item.id}`}
      >
        <div className="aspect-square overflow-hidden bg-amber-50">
          <SmartImage
            image={item.image}
            sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="p-6">
          <span className="inline-block mb-3 rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-amber-700">
            {item.category}
          </span>
          <h3 className="text-xl font-bold text-gray-900 mb-2">{item.name}</h3>
          <p className="text-sm text-gray-600 leading-relaxed">{item.description}</p>
        </div>
      </Card>
    ))}
  </div>
);

export default DonutGrid;
